import {
  PLAN_YEARLY,
  PLAN_MONTHLY,
  PLAN_BUNDLE,
  PLAN_HR,
  PLAN_RECRUITING,
  PLAN_STANDARD,
  PLAN_PREMIER,
  PLAN_ENTERPRISE
} from '@/content/pricing/plans-section/plan.const';
import {createTranslator} from 'next-intl';

const translationStringBase = 'pricing.plansSection';

function getPlanPrices(messages, locale = 'en') {
  const t = createTranslator({locale, messages});

  const PLAN_PRICES = {
    [PLAN_STANDARD]: {
      name: t(`${translationStringBase}.standard.name`),
      hr_enabled: true,
      recruiting_enabled: true,
      services_included: false,
      prices: {
        '1 - 20': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 360,
            [PLAN_YEARLY]: 299
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 120,
            [PLAN_YEARLY]: 99
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 430,
            [PLAN_YEARLY]: 359
          }
        },
        '21 - 50': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 500,
            [PLAN_YEARLY]: 419
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 280,
            [PLAN_YEARLY]: 229
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 695,
            [PLAN_YEARLY]: 579
          }
        },
        '51 - 100': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 800,
            [PLAN_YEARLY]: 669
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 585,
            [PLAN_YEARLY]: 489
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 1245,
            [PLAN_YEARLY]: 1039
          }
        },
        '101 - 200': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 1140,
            [PLAN_YEARLY]: 949
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 1150,
            [PLAN_YEARLY]: 959
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 1945,
            [PLAN_YEARLY]: 1619
          }
        },
        '201 - 400': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 1560,
            [PLAN_YEARLY]: 1299
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 1860,
            [PLAN_YEARLY]: 1549
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 2900,
            [PLAN_YEARLY]: 2419
          }
        },
        '401 - 600': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 2100,
            [PLAN_YEARLY]: 1749
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 2710,
            [PLAN_YEARLY]: 2259
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 3850,
            [PLAN_YEARLY]: 3209
          }
        },
        '601 - 800': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 2700,
            [PLAN_YEARLY]: 2249
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 3600,
            [PLAN_YEARLY]: 2999
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 5040,
            [PLAN_YEARLY]: 4199
          }
        },
        '801 - 1000': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: 3360,
            [PLAN_YEARLY]: 2799
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: 4680,
            [PLAN_YEARLY]: 3899
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: 6430,
            [PLAN_YEARLY]: 5359
          }
        },
        '1000+': {
          [PLAN_RECRUITING]: {
            [PLAN_MONTHLY]: null,
            [PLAN_YEARLY]: null
          },
          [PLAN_HR]: {
            [PLAN_MONTHLY]: null,
            [PLAN_YEARLY]: null
          },
          [PLAN_BUNDLE]: {
            [PLAN_MONTHLY]: null,
            [PLAN_YEARLY]: null
          }
        }
      },
      recruiting_premium_tools: [
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.texting.name`),
          price: {
            '1 - 20': {
              [PLAN_MONTHLY]: 105,
              [PLAN_YEARLY]: 89
            },
            '21 - 50': {
              [PLAN_MONTHLY]: 155,
              [PLAN_YEARLY]: 129
            },
            '51 - 100': {
              [PLAN_MONTHLY]: 240,
              [PLAN_YEARLY]: 199
            },
            '101 - 200': {
              [PLAN_MONTHLY]: 325,
              [PLAN_YEARLY]: 269
            },
            '201 - 400': {
              [PLAN_MONTHLY]: 405,
              [PLAN_YEARLY]: 339
            },
            '401 - 600': {
              [PLAN_MONTHLY]: 505,
              [PLAN_YEARLY]: 419
            },
            '601 - 800': {
              [PLAN_MONTHLY]: 585,
              [PLAN_YEARLY]: 489
            },
            '801 - 1000': {
              [PLAN_MONTHLY]: 685,
              [PLAN_YEARLY]: 569
            },
            '1000+': {
              [PLAN_MONTHLY]: null,
              [PLAN_YEARLY]: null
            }
          }
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.videoInterviews.name`),
          price: {
            '1 - 20': {
              [PLAN_MONTHLY]: 130,
              [PLAN_YEARLY]: 109
            },
            '21 - 50': {
              [PLAN_MONTHLY]: 190,
              [PLAN_YEARLY]: 159
            },
            '51 - 100': {
              [PLAN_MONTHLY]: 360,
              [PLAN_YEARLY]: 299
            },
            '101 - 200': {
              [PLAN_MONTHLY]: 490,
              [PLAN_YEARLY]: 409
            },
            '201 - 400': {
              [PLAN_MONTHLY]: 610,
              [PLAN_YEARLY]: 509
            },
            '401 - 600': {
              [PLAN_MONTHLY]: 740,
              [PLAN_YEARLY]: 619
            },
            '601 - 800': {
              [PLAN_MONTHLY]: 875,
              [PLAN_YEARLY]: 729
            },
            '801 - 1000': {
              [PLAN_MONTHLY]: 1020,
              [PLAN_YEARLY]: 849
            },
            '1000+': {
              [PLAN_MONTHLY]: null,
              [PLAN_YEARLY]: null
            }
          }
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.assessments.name`),
          price: {
            '1 - 20': {
              [PLAN_MONTHLY]: 70,
              [PLAN_YEARLY]: 59
            },
            '21 - 50': {
              [PLAN_MONTHLY]: 120,
              [PLAN_YEARLY]: 99
            },
            '51 - 100': {
              [PLAN_MONTHLY]: 200,
              [PLAN_YEARLY]: 169
            },
            '101 - 200': {
              [PLAN_MONTHLY]: 250,
              [PLAN_YEARLY]: 209
            },
            '201 - 400': {
              [PLAN_MONTHLY]: 310,
              [PLAN_YEARLY]: 259
            },
            '401 - 600': {
              [PLAN_MONTHLY]: 385,
              [PLAN_YEARLY]: 319
            },
            '601 - 800': {
              [PLAN_MONTHLY]: 455,
              [PLAN_YEARLY]: 379
            },
            '801 - 1000': {
              [PLAN_MONTHLY]: 540,
              [PLAN_YEARLY]: 449
            },
            '1000+': {
              [PLAN_MONTHLY]: null,
              [PLAN_YEARLY]: null
            }
          }
        }
      ],
      hr_premium_tools: [
        {
          name: t(`${translationStringBase}.hrPremiumTools.performanceReviews.name`),
          price: {
            '1 - 20': {
              [PLAN_MONTHLY]: 50,
              [PLAN_YEARLY]: 39
            },
            '21 - 50': {
              [PLAN_MONTHLY]: 130,
              [PLAN_YEARLY]: 109
            },
            '51 - 100': {
              [PLAN_MONTHLY]: 300,
              [PLAN_YEARLY]: 249
            },
            '101 - 200': {
              [PLAN_MONTHLY]: 515,
              [PLAN_YEARLY]: 429
            },
            '201 - 400': {
              [PLAN_MONTHLY]: 695,
              [PLAN_YEARLY]: 579
            },
            '401 - 600': {
              [PLAN_MONTHLY]: 850,
              [PLAN_YEARLY]: 709
            },
            '601 - 800': {
              [PLAN_MONTHLY]: 985,
              [PLAN_YEARLY]: 819
            },
            '801 - 1000': {
              [PLAN_MONTHLY]: 1115,
              [PLAN_YEARLY]: 929
            },
            '1000+': {
              [PLAN_MONTHLY]: null,
              [PLAN_YEARLY]: null
            }
          }
        }
      ],
      features: [
        {
          name: t(`${translationStringBase}.features.candidateSourcingSuite.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.applicantTrackingSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.unlimitedActiveJobs.name`),
          included: true,
          tooltip: t(`${translationStringBase}.features.unlimitedActiveJobs.tooltip`)
        },
        {
          name: t(`${translationStringBase}.features.hiringPlan.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.nativeLanguageOptions.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: false
        }
      ],
      hr_features: [
        {
          name: t(`${translationStringBase}.hrFeatures.hrInformationSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.employeeOnboarding.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeOffManagement.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeTracking.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.esignaturesForCompanyFiles.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollPreparation.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollIntegrations.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: false
        }
      ],
      bundleDiscount: 20
    },
    [PLAN_PREMIER]: {
      name: t(`${translationStringBase}.premier.name`),
      hr_enabled: true,
      recruiting_enabled: true,
      yearly_only: true,
      services_included: true,
      addons_included: true,
      prices: {
        '1 - 20': {
          [PLAN_RECRUITING]: 599,
          [PLAN_HR]: 239,
          [PLAN_BUNDLE]: 749
        },
        '21 - 50': {
          [PLAN_RECRUITING]: 829,
          [PLAN_HR]: 559,
          [PLAN_BUNDLE]: 1249
        },
        '51 - 100': {
          [PLAN_RECRUITING]: 1229,
          [PLAN_HR]: 969,
          [PLAN_BUNDLE]: 1979
        },
        '101 - 200': {
          [PLAN_RECRUITING]: 1759,
          [PLAN_HR]: 1619,
          [PLAN_BUNDLE]: 2869
        },
        '201 - 400': {
          [PLAN_RECRUITING]: 2269,
          [PLAN_HR]: 2429,
          [PLAN_BUNDLE]: 3989
        },
        '401 - 600': {
          [PLAN_RECRUITING]: 2809,
          [PLAN_HR]: 3309,
          [PLAN_BUNDLE]: 4889
        },
        '601 - 800': {
          [PLAN_RECRUITING]: 3369,
          [PLAN_HR]: 4089,
          [PLAN_BUNDLE]: 5969
        },
        '801 - 1000': {
          [PLAN_RECRUITING]: 3959,
          [PLAN_HR]: 4929,
          [PLAN_BUNDLE]: 7109
        },
        '1000+': {
          [PLAN_RECRUITING]: null,
          [PLAN_HR]: null,
          [PLAN_BUNDLE]: null
        }
      },
      recruiting_premium_tools: [
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.texting.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.videoInterviews.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.assessments.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.referrals.name`),
          included: true
        }
      ],
      hr_premium_tools: [
        {
          name: t(`${translationStringBase}.hrPremiumTools.performanceReviews.name`),
          included: true
        }
      ],
      features: [
        {
          name: t(`${translationStringBase}.features.candidateSourcingSuite.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.applicantTrackingSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.unlimitedActiveJobs.name`),
          included: true,
          tooltip: t(`${translationStringBase}.features.unlimitedActiveJobs.tooltip`)
        },
        {
          name: t(`${translationStringBase}.features.hiringPlan.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.nativeLanguageOptions.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: false
        }
      ],
      hr_features: [
        {
          name: t(`${translationStringBase}.hrFeatures.hrInformationSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.employeeOnboarding.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeOffManagement.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeTracking.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.esignaturesForCompanyFiles.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollPreparation.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollIntegrations.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: false
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: false
        }
      ],
      bundleDiscount: 20
    },
    [PLAN_ENTERPRISE]: {
      name: t(`${translationStringBase}.enterprise.name`),
      hr_enabled: true,
      recruiting_enabled: true,
      yearly_only: true,
      services_included: true,
      addons_included: true,
      prices: {
        '1 - 20': {
          [PLAN_RECRUITING]: 719,
          [PLAN_HR]: 289,
          [PLAN_BUNDLE]: 899
        },
        '21 - 50': {
          [PLAN_RECRUITING]: 989,
          [PLAN_HR]: 669,
          [PLAN_BUNDLE]: 1499
        },
        '51 - 100': {
          [PLAN_RECRUITING]: 1469,
          [PLAN_HR]: 1159,
          [PLAN_BUNDLE]: 2369
        },
        '101 - 200': {
          [PLAN_RECRUITING]: 2109,
          [PLAN_HR]: 1939,
          [PLAN_BUNDLE]: 3439
        },
        '201 - 400': {
          [PLAN_RECRUITING]: 2719,
          [PLAN_HR]: 2909,
          [PLAN_BUNDLE]: 4789
        },
        '401 - 600': {
          [PLAN_RECRUITING]: 3369,
          [PLAN_HR]: 3969,
          [PLAN_BUNDLE]: 5869
        },
        '601 - 800': {
          [PLAN_RECRUITING]: 4039,
          [PLAN_HR]: 4909,
          [PLAN_BUNDLE]: 7159
        },
        '801 - 1000': {
          [PLAN_RECRUITING]: 4749,
          [PLAN_HR]: 5909,
          [PLAN_BUNDLE]: 8529
        },
        '1000+': {
          [PLAN_RECRUITING]: null,
          [PLAN_HR]: null,
          [PLAN_BUNDLE]: null
        }
      },
      recruiting_premium_tools: [
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.texting.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.videoInterviews.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.assessments.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.recruitingPremiumTools.referrals.name`),
          included: true
        }
      ],
      hr_premium_tools: [
        {
          name: t(`${translationStringBase}.hrPremiumTools.performanceReviews.name`),
          included: true
        }
      ],
      features: [
        {
          name: t(`${translationStringBase}.features.candidateSourcingSuite.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.applicantTrackingSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.unlimitedActiveJobs.name`),
          included: true,
          tooltip: t(`${translationStringBase}.features.unlimitedActiveJobs.tooltip`)
        },
        {
          name: t(`${translationStringBase}.features.hiringPlan.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.nativeLanguageOptions.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: true
        }
      ],
      hr_features: [
        {
          name: t(`${translationStringBase}.hrFeatures.hrInformationSystem.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.employeeOnboarding.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeOffManagement.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.timeTracking.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.esignaturesForCompanyFiles.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollPreparation.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.hrFeatures.payrollIntegrations.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.customReportBuilder.name`),
          included: true
        },
        {
          name: t(`${translationStringBase}.features.additionalPermissionSets.name`),
          included: true
        }
      ],
      bundleDiscount: 20
    }
  };

  return PLAN_PRICES;
}

export {getPlanPrices};
